export default __webpack_public_path__ + "static/media/HipExtensionAtTerminalStance.1b73de8a.png";